module.exports = __webpack_public_path__ + "media/images/pages/img_close_qr-f1d007cffd177f873ee1e91fae511fba.png";